import { render, staticRenderFns } from "./ForumsListNotConfirmed.vue?vue&type=template&id=78847cc6&scoped=true&"
import script from "./ForumsListNotConfirmed.vue?vue&type=script&lang=js&"
export * from "./ForumsListNotConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78847cc6",
  null
  
)

export default component.exports